import { isMockMode, post, simulateDelay } from "../api";

export const resendSubInvite = (data) => {
	if (isMockMode()) {
		const testData = { success: true };

		return simulateDelay(50, () => testData);
	}

	return post(`Subscriptions/ResendInvite`, data);
};
